import { useTranslation } from "react-i18next";

import {
  changeKareokeLanguage,
  normaliseLanguage,
  reportLanguageChangeFailure,
  SUPPORTED_LANGUAGES,
} from "../i18n/i18n";
import type { SupportedLanguage } from "../i18n/resources";
import { useNotifications } from "../notifications/useNotifications";

const LANGUAGE_LABEL_KEYS: Record<SupportedLanguage, string> = {
  tr: "language.turkish",
  en: "language.english",
};

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const { notifyError } = useNotifications();
  const selectedLanguage = normaliseLanguage(i18n.language);

  function handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const nextLanguage = normaliseLanguage(event.target.value);
    void changeKareokeLanguage(nextLanguage).catch((error: unknown) => {
      reportLanguageChangeFailure(error);
      notifyError(t("language.changeError"));
    });
  }

  return (
    <label className="flex items-center gap-2 text-sm text-stone-300">
      <span>{t("language.label")}</span>
      <select
        value={selectedLanguage}
        onChange={handleChange}
        className="rounded-lg border border-stone-700 bg-stone-950 px-2 py-1 text-sm text-stone-100 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/40"
      >
        {SUPPORTED_LANGUAGES.map((language) => (
          <option key={language} value={language}>
            {t(LANGUAGE_LABEL_KEYS[language])}
          </option>
        ))}
      </select>
    </label>
  );
}
